<template>
<v-dialog v-model='session' width=500 persistent>
    <v-card>
      <v-card-title>{{ number }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col :key=n*10 cols=4 v-for='n of ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"]'>
            <v-btn :key='n' @click='$sip.dtmf(n)'>{{ n }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click='$sip.bye'>Hang Up</v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>
</template>



<script >

import { mapState } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  data: function() {
    return {
      
    }
  },

  props: {
  },
  computed: {
    ...mapState([
      'deviceId',
      'device', 
      'conferences',
      'isDevelopment',
      'number',
      'user',
      'userId'
    ]),
    click2call: function() {
      if (this.device) {
        return this.device.click2call_token; 
      } else {
        return null;
      }
    },
    number: {
      get: function() { return this.$store.state.number; },
      set: function(v) { this.$store.commit('number',v)}
    },
  },
  components: {
    
  },
  methods: {
    async getMediaInputPermissionIfNotSet() {
      // get mic permission if its not already granted
      let permissionStatus = await navigator.permissions.query(
          // { name: 'camera' }
          { name: 'microphone' }
          // { name: 'geolocation' }
          // { name: 'notifications' } 
          // { name: 'midi', sysex: false }
          // { name: 'midi', sysex: true }
          // { name: 'push', userVisibleOnly: true }
          // { name: 'push' } // without userVisibleOnly isn't supported in chrome M45, yet
      )

      permissionStatus.onchange = function(){
          console.log("Permission changed to " + this.state);
      }
      console.log(permissionStatus.state); // granted, denied, prompt
      if (permissionStatus.state != 'granted') {
        
        try {
          let stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          console.log('You let me use your mic!');

          // set a default mic to get going
          if (!this.$store.state.microphoneId) {
            let noMic = true;
            let noSpeaker = true;
            let mediaDeviceInfos = await window.navigator.mediaDevices.enumerateDevices();
            for (let i=0;i<mediaDeviceInfos.length;i++) {
              let mdi = mediaDeviceInfos[i];
              if ((mdi.deviceId == 'default') || (mdi.deviceId == 'communications')) {
                continue;
              }
              if (mdi.kind == 'audioinput') {
                if (noMic) this.$store.dispatch('setMicrophoneId',mdi.deviceId);
                noMic = false;
              } else if (mdi.kind == 'audiooutput') {
                if (noSpeaker) this.$store.dispatch('setSpeakerId',mdi.deviceId)
                noSpeaker = false;
              }
            }
          }
        } catch(error) {
          console.log('No mic for you!');
          console.log(error);
          alert('Microphone access is blocked. Please go to settings.');

        }
      }
    }
  },
  mounted() {
    let self = this;
    setTimeout(function() {
      if (!self.click2call) {
        // messaging doesn't need a device
        if (self.$route.name == 'chats')
          return;
        if (self.$route.name == 'chat') 
          return;
        if (self.$route.params.confId) return;

        //everything else does
        self.$router.push('/prefs');
      }
    }, 5000)
    
  },
});

</script>

<style scoped>

div[class*="col-"] {
  background: #fff;
  text-align: center;
  color: #000;
  border: 0px solid #ddd;
  padding: 5px;
}
.row {
  margin-bottom: 0px;
}

</style>
